import React from 'react';

import { LazyPicture } from 'src/hooks/useLazyLoad';

import type { CustomCSSProperties } from '../../../types/pbTypes';
import type { ImageType } from '../imageConfigAggregator';

import classes from './Image.module.scss';

type ImageProps = ImageType & {
    figureStyles: CustomCSSProperties;
    pictureStyles: CustomCSSProperties;
};

/**
 * Return the PB Image
 * @param props
 * @constructor
 */
export function Image(props: ImageProps) {
    const imageClassNames = [classes['root'], 'pageBuilderImageGlobal'];

    if (props.cssClasses && props.cssClasses.length > 0) {
        imageClassNames.push(...props.cssClasses);
    }

    return (
        <figure
            data-content-type={props.contentType}
            data-pb-style={props.uniqueID}
            className={imageClassNames.join(' ')}
            style={props.figureStyles}
        >
            <LazyPicture data-alt={props.altText} className={classes['imageContainer']} style={props.pictureStyles}>
                <source media="(min-width: 750px)" srcSet={props.desktopImage} />
                <source media="(max-width: 750px)" srcSet={props.mobileImage} />
            </LazyPicture>
            <figcaption>{props.caption}</figcaption>
        </figure>
    );
}
